module.exports = __webpack_public_path__ + "95a8b13a9b3a3a30cb4c85d9b538ddb9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/joey-bada-ft-bj-the-chicago-kid-like-me-official-music-video.png
// module id = 543
// module chunks = 0